import api from './interceptor';

const BASE_URL_V1 = 'api/v1/countries';

export default {
  // API Version 1
  getCountries: () => api.get(`${BASE_URL_V1}`),
  getStates: (countryId) => api.get(`${BASE_URL_V1}/${countryId}/states`),
};
